import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { formatFlexibleDate } from '../../../../utils/safe-date.util';

@Component({
    selector: 'app-undisclosed-income-en-v2',
    templateUrl: './undisclosed-income-en-v2.component.html',
    styleUrls: ['./undisclosed-income-en-v2.component.css'],
    standalone: false
})
export class UndisclosedIncomeEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  undisclosedIncome: any[] = [];
  verificationMessage = "I solemnly declare that the disclosed income is derived from legitimate sources and not from any criminal activities under any other law for the time being in force. To the best of my knowledge there is no pending proceeding against me under section 200 or 212 or 311 or 312 or 313 of Income Tax Act ,2023 .";

  taxPaid: number = 0;
  penaltyPaid: number = 0;
  dateAfterSign: string = '';
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.undisclosedIncome = this.returnData?.headSummery?.undisclosedSummary?.undisclosedIncomeList;
    this.taxPaid = Math.round(this.returnData?.taxPaymentData?.tc_Undisclosed_Tax_Amt);
    this.penaltyPaid = Math.round(this.returnData?.taxPaymentData?.tc_Undisclosed_Penalty_Amt);
    this.dateAfterSign = formatFlexibleDate(this.returnData && this.returnData.submissionInfo ? this.returnData.submissionInfo.submissionDate : null, '/');
  }
}
